import { ConfigurableFormElementConfig } from "../../../types";

// ConfigurableForm/SectionHeader
export const sectionHeader: ConfigurableFormElementConfig = {
  component: "SectionHeader",
  label: "REPLACE"
};

// ConfigurableForm/SectionText
export const sectionText: ConfigurableFormElementConfig = {
  component: "SectionText",
  label: "REPLACE"
};

// Group of elements
export const group: ConfigurableFormElementConfig = {
  component: "Group",
  id: "REPLACE"
  // label: ""
  // fields: []
};

export const customerConsentIntro: ConfigurableFormElementConfig = {
  component: "CustomerConsentIntro",
  id: "customer-consent-intro"
};

// Input
export const fieldText: ConfigurableFormElementConfig = {
  component: "Field",
  type: "text",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

export const fieldTax: ConfigurableFormElementConfig = {
  component: "Field",
  type: "tax",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

// Input
export const fieldTextarea: ConfigurableFormElementConfig = {
  component: "Field",
  type: "textarea",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

export const fieldNumber: ConfigurableFormElementConfig = {
  component: "Field",
  type: "number",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

export const fieldEmailDqe: ConfigurableFormElementConfig = {
  component: "Field",
  type: "emailDqe",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

export const fieldEmail: ConfigurableFormElementConfig = {
  component: "Field",
  type: "email",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

// InputCheckbox
export const fieldCheckbox: ConfigurableFormElementConfig = {
  component: "Field",
  type: "checkbox",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      switchMode: false
    }
  }
};

// InputRadioGroup
export const fieldRadioGroup: ConfigurableFormElementConfig = {
  component: "Field",
  type: "radioGroup",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      options: [
        {
          label: "REPLACE",
          value: "REPLACE"
        }
      ]
    }
  }
};

// InputRadio
export const fieldRadio: ConfigurableFormElementConfig = {
  component: "Field",
  type: "radio",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      switchMode: false
    }
  }
};

// InputSelect
export const fieldDropdown: ConfigurableFormElementConfig = {
  component: "Field",
  type: "dropdown",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      options: [
        {
          label: "REPLACE",
          value: "REPLACE"
        }
      ]
    }
  }
};

// InputSelectCustom
export const fieldDropdownCustom: ConfigurableFormElementConfig = {
  component: "Field",
  type: "dropdownCustom",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      options: [
        {
          label: "REPLACE",
          value: "REPLACE"
        }
      ]
    }
  }
};

// InputTags
export const fieldTags: ConfigurableFormElementConfig = {
  component: "Field",
  type: "tags",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      options: [
        {
          label: "REPLACE",
          value: "REPLACE"
        }
      ]
    }
  }
};

// fieldPhoneDqe
export const fieldPhoneDqe: ConfigurableFormElementConfig = {
  component: "Field",
  type: "PhoneDqe",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      country: null,
      labels: {
        dialCode: "",
        phoneNumber: ""
      }
    }
  }
};
// InputPhone
export const fieldPhone: ConfigurableFormElementConfig = {
  component: "Field",
  type: "phone",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      country: null,
      labels: {
        dialCode: "",
        phoneNumber: ""
      }
    }
  }
};

export const fieldTitle: ConfigurableFormElementConfig = {
  component: "Field",
  type: "title",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

export const fieldCustomPicklist: ConfigurableFormElementConfig = {
  component: "Field",
  type: "customPicklist",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

// InputYearMonthDay
export const fieldDate: ConfigurableFormElementConfig = {
  component: "Field",
  type: "date",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      searchable: true,
      labels: {
        day: "",
        month: "",
        year: "",
        dayOptionNotSet: "",
        monthOptionNotSet: "",
        yearOptionNotSet: ""
      }
    }
  }
};

// InputDateOfBirth
export const fieldBirthDate: ConfigurableFormElementConfig = {
  component: "Field",
  type: "birthDate",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      searchable: true,
      labels: {
        day: "",
        month: "",
        year: "",
        dayOptionNotSet: "",
        monthOptionNotSet: "",
        yearOptionNotSet: ""
      },
      minimumAge: 16,
      maximumAge: 120
    }
  }
};

// InputCountry
export const fieldCountry: ConfigurableFormElementConfig = {
  component: "Field",
  type: "country",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};

// InputCountryRegion
export const fieldCountryRegion: ConfigurableFormElementConfig = {
  component: "Field",
  type: "countryRegion",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      country: null
    }
  }
};

// InputSignature
export const fieldSignature: ConfigurableFormElementConfig = {
  component: "Field",
  type: "signature",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      labels: {
        clear: ""
      }
    }
  }
};
export const fieldAutocompleteGoogleMaps: ConfigurableFormElementConfig = {
  component: "Field",
  type: "textAutocompleteGoogleMaps",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      country: null
    }
  }
};
export const fieldAutocompleteDqe: ConfigurableFormElementConfig = {
  component: "Field",
  type: "textAutocompleteDqe",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE",
  props: {
    inputProps: {
      country: null
    }
  }
};
export const fieldCpf: ConfigurableFormElementConfig = {
  component: "Field",
  type: "InputCpfField",
  id: "REPLACE",
  name: "REPLACE",
  label: "REPLACE"
};
